import { z } from 'zod';
import { DISPOSAL_PURPOSE_SCHEMA } from '../../product-channel/disposal-purpose.ts';
import { DangerousWasteProductTypes, MATERIAL_PRODUCT_TYPES_SCHEMA, WasteProductTypes } from './material-types.ts';

export const PayloadMaterialSchema = z.object({
    name: z.string(),
    isRecycled: z.boolean().default(false),
    locationId: z.string().nullish(),
    referenceId: z.string().nullish(),
    referenceSource: z.string().nullish(),
    sellerProductId: z.string().nullish(),
    productDefinitionId: z.string().nullish(),
});

export const PayloadMaterialWasteSchema = z
    .object({
        pollutionType: z.string().nullish(),
        wasteCode: z.string().nullish(),
        disposalPurpose: DISPOSAL_PURPOSE_SCHEMA.nullish(),
    })
    .merge(PayloadMaterialSchema);

export const PayloadMaterialWasteDangerousSchema = z
    .object({
        disposalProofNumber: z.string().nullish(),
    })
    .merge(PayloadMaterialWasteSchema);

export const MaterialPayloadDiscriminatedSchema = z.discriminatedUnion('productType', [
    z.object({
        productType: MATERIAL_PRODUCT_TYPES_SCHEMA.exclude([
            ...WasteProductTypes.options,
            ...DangerousWasteProductTypes.options,
        ]),
        payload: PayloadMaterialSchema,
    }),
    z.object({
        productType: WasteProductTypes,
        payload: PayloadMaterialWasteSchema,
    }),
    z.object({
        productType: DangerousWasteProductTypes,
        payload: PayloadMaterialWasteDangerousSchema,
    }),
]);

export const MaterialPayloadPartialDiscriminatedSchema = z.discriminatedUnion('productType', [
    z.object({
        productType: MATERIAL_PRODUCT_TYPES_SCHEMA.exclude([
            ...WasteProductTypes.options,
            ...DangerousWasteProductTypes.options,
        ]),
        payload: PayloadMaterialSchema.partial().nullish(),
    }),
    z.object({
        productType: WasteProductTypes,
        payload: PayloadMaterialWasteSchema.partial().nullish(),
    }),
    z.object({
        productType: DangerousWasteProductTypes,
        payload: PayloadMaterialWasteDangerousSchema.partial().nullish(),
    }),
]);
